import { render } from "./map-v2.vue?vue&type=template&id=efa5a61c"
import script from "./map-v2.vue?vue&type=script&lang=js"
export * from "./map-v2.vue?vue&type=script&lang=js"

import "./map-v2.vue?vue&type=style&index=0&id=efa5a61c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__